var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sub-container" },
    [
      _c("new-subscription-modal", {
        attrs: {
          subscription: _vm.subscription,
          active: _vm.showSubscriptionModal,
          intro: _vm.intro
        },
        on: { refreshsubscription: _vm.refreshSubscription }
      }),
      _vm._v(" "),
      _c("new-waitlist-modal", {
        attrs: {
          subscription: _vm.subscription,
          active: _vm.showWaitlistModal
        },
        on: { refreshsubscription: _vm.refreshSubscription }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b439807a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b439807a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/subscription/SubscriptionModalContainer.vue
// module id = IzjS
// module chunks = 1